import styled, { css } from 'styled-components'
import { COLORS } from 'consts/colors'
import { SMALL_DESKTOP_SIZE_BREAKPOINT } from 'consts'
import { SIDEBAR_MOBILE_Z_INDEX } from 'consts/zIndex'

export const Sidebar = styled.aside`
  background-color: ${COLORS.primaryExtraLight};
  width: 72px;
  height: 100%;
  border-right: 1px solid ${COLORS.borderColor};
  flex-shrink: 0;
  z-index: ${SIDEBAR_MOBILE_Z_INDEX};
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 100%;
    height: 64px;
    border-right: none;
    border-top: 1px solid ${COLORS.borderColor};
    display: flex;
    flex-direction: row;
    position: relative;
    overflow-x: auto;
    overflow-y: hidden;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`

export const SidebarLogoWrapper = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 64px;
  border-bottom: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    display: none;
  }

  & > img {
    width: 24px;
    height: 32px;
  }
`

export const SidebarItemWrapper = styled.div<{ $isActive: boolean }>`
  text-decoration: none;
  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    width: 50%;
    min-width: 72px;
    border-right: 1px solid ${COLORS.borderColor};
    margin-top: ${({ $isActive }) => ($isActive ? '-1px' : '0px')};
  }
`

export const SidebarItem = styled.div<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  align-items: center;
  justify-content: center;
  text-align: center;
  height: 72px;
  border-bottom: 1px solid ${COLORS.borderColor};
  box-sizing: border-box;
  position: relative;
  & > span {
    font-size: 11px;
    font-weight: 500;
    color: ${COLORS.secondarySemiDark};
    margin-top: 6px;
    word-break: break-word;
  }

  & > svg path {
    fill: ${COLORS.secondarySemiDark};
  }

  ${({ $isActive }) =>
    $isActive
      ? css`
          background-color: ${COLORS.white};
          margin-right: -1px;
          cursor: default;

          & > svg path {
            fill: ${COLORS.secondaryDark};
          }
        `
      : css`
          cursor: pointer;
          &:hover {
            background-color: ${COLORS.primaryLight};

            & > svg path {
              fill: ${COLORS.secondaryDark};
            }

            & > span {
              color: ${COLORS.secondaryDark};
            }
          }
        `}

  @media only screen and (max-width: ${SMALL_DESKTOP_SIZE_BREAKPOINT}px) {
    margin-right: unset;
  }
`

export const NewLabel = styled.img`
  width: 35px;
  position: absolute;
  top: -1px;
  right: -1px;
`
